const shortenString = (str: string, maxLength = 20, lastPartLength = 4) => {
	if (maxLength < 4) {
		throw new Error("maxLength cannot be lower than 4");
	}

	if (lastPartLength < 0) {
		throw new Error("lastPartLength cannot be negative");
	}

	const ellipsis = "...";
  
	if (str.length <= maxLength) {
		return str;
	}
	
	const availableLength = maxLength - ellipsis.length - lastPartLength;

	if (availableLength <= 0) {
		throw new Error("maxLength must be greater than the length of the ellipsis and lastPartLength combined.");
	}
  
	const firstPartLength = availableLength;
  
	const firstPart = str.slice(0, firstPartLength);
	const lastPart = lastPartLength > 0 ? str.slice(-lastPartLength) : "";
  
	return `${firstPart}${ellipsis}${lastPart}`;
};

export default shortenString;
